// extracted by mini-css-extract-plugin
export default {"description":"mail_description__HjMTm","type":"mail_type__xbjgC","icon":"mail_icon__ETWid"};